import { useEffect } from "react";
import { useTrads } from "../../contexts/trads/useTrads";
import type { Fond } from "../../types/Fond";
import { FondStatutSelectorBootstrap } from "./FondStatutSelectorBootstrap";
import type { ResponseError } from "../../types/CommonReponse";
import { useUpdateFondMutation } from "../../stores/OkOkStore";
import { useForm } from "react-hook-form";

type FondStatut = Pick<Fond, 'id' | 'statut'>

export function FondStatutManager({fond}:{fond:FondStatut}){
    const [updateFond,result]=useUpdateFondMutation();
    const { register, handleSubmit,setError, formState: { errors } } = useForm({
        defaultValues:fond,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();
    console.log(fond);

    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result, translate]);


    return (
        <>
        {result.isSuccess ? <p className="p-3 mb-2 bg-success text-white">{translate('msg_fond_update')}</p>  :
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :null}
        {result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :

            <form className="row" onSubmit={(event) => void handleSubmit(updateFond)(event)}>
            <div className="col-8  mb-3">
            <FondStatutSelectorBootstrap 
                statut={fond.statut} 
                name="statut"
                label={translate('fond_statut')} 
                registerOutput={register("statut", {
                        required: translate("fond_error_statut_requis"),
                    })} 
                errors={errors}></FondStatutSelectorBootstrap>

            </div>
            <div className="col-4  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>

            </form>
        }
        </>
    )
}